import { Column } from '@devexpress/dx-react-grid';


export const REDEMPTION_TYPE_EDITOR_OPTIONS: ReadonlyArray<string> = ['online', 'offline'];

export type MyColumn = Column & {
    filterable?: boolean,
    editable?: boolean,
    editorOptions?: ReadonlyArray<string>,
}